import { request } from './httpClient';

export function createOrder(body) {
  return request({ method: 'POST', url: '/v1/order', data: body });
}

export function getOrders(params) {
  return request({ method: 'GET', url: '/v1/orders', params });
}

export function getOrder(orderId) {
  return request({ method: 'GET', url: `/v1/order/${encodeURIComponent(orderId)}` });
}

export function getOrderLines(orderId, params) {
  return request({ method: 'GET', url: `/v1/order/${encodeURIComponent(orderId)}/lines`, params });
}

export function getOrderLine(orderId, lineId) {
  return request({ method: 'GET', url: `/v1/order/${encodeURIComponent(orderId)}/line/${encodeURIComponent(lineId)}` });
}

export function getOrderCounts(params) {
  return request({ method: 'GET', url: '/v1/order/counts', params });
}

export function updateCustomerExchangeSummary(id, body) {
  return request({ method: 'POST', url: `/v1/ces/${encodeURIComponent(id)}`, data: body });
}

